import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#create_entity",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Add Batch")
  ])
], -1)
const _hoisted_3 = {
  id: "create_entity",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-9" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Course", -1)
const _hoisted_18 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#batch_detail",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Batch Detail")
  ])
], -1)
const _hoisted_20 = {
  id: "batch_detail",
  class: "collapse show"
}
const _hoisted_21 = { class: "collapse show" }
const _hoisted_22 = { class: "card-body border-top p-9" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Batch Number", -1)
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Custom Batch Number", -1)
const _hoisted_28 = { class: "col-md-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Location", -1)
const _hoisted_30 = { class: "col-md-3" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Capacity", -1)
const _hoisted_32 = { class: "row mt-4" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", {
  for: "start_date",
  class: "form-label required"
}, "Start Date ", -1)
const _hoisted_35 = { class: "col-md-3" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "End Date ", -1)
const _hoisted_37 = { class: "col-md-3" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Course Duration (Month)", -1)
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Total Training Days", -1)
const _hoisted_41 = { class: "row mt-4" }
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Training Session", -1)
const _hoisted_44 = { class: "col-md-3" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Total Training Hours", -1)
const _hoisted_46 = { class: "col-md-3" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Total Terms", -1)
const _hoisted_48 = { class: "col-md-3" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Dropout %", -1)
const _hoisted_50 = {
  key: 1,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#week_plan",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Batch Week Plan")
  ])
], -1)
const _hoisted_52 = {
  id: "week_plan",
  class: "collapse show"
}
const _hoisted_53 = { class: "collapse show" }
const _hoisted_54 = { "data-kt-stepper-element": "content" }
const _hoisted_55 = { class: "row" }
const _hoisted_56 = { class: "col-md-3" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Term", -1)
const _hoisted_58 = { class: "col-md-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Term Day", -1)
const _hoisted_60 = { class: "col-md-3" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Term Session", -1)
const _hoisted_62 = { class: "col-md-3" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Term Hour", -1)
const _hoisted_64 = { class: "row mt-3" }
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Class Type", -1)
const _hoisted_67 = { class: "col-md-3" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Start Date ", -1)
const _hoisted_69 = { class: "col-md-3" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "End Date ", -1)
const _hoisted_71 = { class: "table-responsive" }
const _hoisted_72 = { class: "table table-row-dashed table-row-gray-600 align-middle gs-0 gy-4" }
const _hoisted_73 = { class: "fw-bolder text-dark" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-60px required" }, "Day", -1)
const _hoisted_75 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-80px required" }, "Training Room", -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px required" }, "Start Time", -1)
const _hoisted_77 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-40px required" }, "End Time", -1)
const _hoisted_78 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-60px required" }, "Duration(H)", -1)
const _hoisted_79 = {
  key: 0,
  class: "min-w-100px required"
}
const _hoisted_80 = {
  key: 1,
  class: "min-w-100px required"
}
const _hoisted_81 = { class: "col-md-2" }
const _hoisted_82 = { class: "col-md-2" }
const _hoisted_83 = { class: "col-md-1" }
const _hoisted_84 = ["name", "onUpdate:modelValue", "onBlur"]
const _hoisted_85 = { class: "col-md-1" }
const _hoisted_86 = ["name", "onUpdate:modelValue", "onBlur"]
const _hoisted_87 = { class: "col-md-1" }
const _hoisted_88 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_89 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_90 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_91 = ["data-kt-indicator"]
const _hoisted_92 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_93 = { class: "svg-icon svg-icon-3 ms-2 me-0" }
const _hoisted_94 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_95 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_Form, {
    onSubmit: _ctx.submit,
    class: "form",
    "validation-schema": _ctx.BatchSchema
  }, {
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _hoisted_10,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      name: "tranche_id",
                      placeholder: "Select Tranche",
                      modelValue: _ctx.batch.tranche_id,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: tranche.id,
                            label: tranche.label,
                            value: tranche.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tranche.label), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _hoisted_13,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Training Partner",
                      name: "entity_id",
                      modelValue: _ctx.batch.entity_id,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.getTrainingInstitute
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: 
                        '[' + info.entity_short_name + '] - ' + info.entity_name
                      ,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Institute",
                      modelValue: _ctx.batch.institute_id,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                      name: "institute_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _ctx.courseInfo
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.institute_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.institute_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _createVNode(_component_el_select, {
                      class: "form-select-solid",
                      placeholder: "Select Course",
                      modelValue: _ctx.batch.course_id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.course_id) = $event)),
                      name: "course_id",
                      filterable: "",
                      style: {"width":"100%"},
                      onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.checkBatchEligibility()))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseList, (info) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: info.id,
                            label: info.course_name,
                            value: info.id
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(info.course_name), 1)
                            ]),
                            _: 2
                          }, 1032, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.loading]
      ]),
      (_ctx.showCourseNotice)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.details.sequence_number,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.details.sequence_number) = $event)),
                        type: "text",
                        name: "sequence_number",
                        class: "form-control form-control-sm text-right",
                        disabled: "",
                        value: ""
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "sequence_number",
                        class: "fv-plugins-message-container invalid-feedback"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _hoisted_27,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.details.batch_number,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.details.batch_number) = $event)),
                        type: "text",
                        name: "batch_number",
                        class: "form-control form-control-sm text-right",
                        value: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.details.training_location,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.details.training_location) = $event)),
                        type: "text",
                        name: "training_location",
                        class: "form-control form-control-sm text-right"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_30, [
                      _hoisted_31,
                      _createVNode(_component_Field, {
                        modelValue: _ctx.details.training_capacity,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.details.training_capacity) = $event)),
                        type: "text",
                        name: "training_capacity",
                        class: "form-control form-control-sm text-right",
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createVNode(_component_el_form_item, {
                          prop: "date",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.details.start_date,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.details.start_date) = $event)),
                              "value-format": "YYYY-MM-DD",
                              format: "DD-MM-YYYY",
                              type: "date",
                              name: "start_date",
                              onBlur: _cache[10] || (_cache[10] = ($event: any) => (
                        _ctx.generateEndDate(
                          _ctx.details.start_date,
                          _ctx.details.course_duration
                        )
                      ))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_35, [
                        _hoisted_36,
                        _createVNode(_component_el_form_item, {
                          prop: "date",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              modelValue: _ctx.details.end_date,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.details.end_date) = $event)),
                              "value-format": "YYYY-MM-DD",
                              format: "DD-MM-YYYY",
                              type: "date",
                              name: "end_date"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_37, [
                        _hoisted_38,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.details.course_duration,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.details.course_duration) = $event)),
                          type: "text",
                          name: "course_duration",
                          class: "form-control form-control-sm text-right",
                          value: "6"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_39, [
                        _hoisted_40,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.details.total_training_days,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.details.total_training_days) = $event)),
                          type: "text",
                          name: "total_training_days",
                          class: "form-control form-control-sm text-right",
                          disabled: "",
                          value: "6"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("div", _hoisted_42, [
                        _hoisted_43,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.details.training_session,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.details.training_session) = $event)),
                          type: "text",
                          name: "training_session",
                          class: "form-control form-control-sm text-right",
                          disabled: "",
                          value: "6"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _hoisted_45,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.details.total_training_hours,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.details.total_training_hours) = $event)),
                          type: "text",
                          name: "total_training_hours",
                          class: "form-control form-control-sm text-right",
                          disabled: "",
                          value: "6"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_46, [
                        _hoisted_47,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.details.terms,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.details.terms) = $event)),
                          type: "text",
                          name: "terms",
                          class: "form-control form-control-sm text-right",
                          disabled: "",
                          value: "6"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _hoisted_49,
                        _createVNode(_component_Field, {
                          modelValue: _ctx.details.dropout_below_perc,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.details.dropout_below_perc) = $event)),
                          type: "text",
                          name: "dropout_below_perc",
                          class: "form-control form-control-sm text-right",
                          disabled: "",
                          value: "6"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.loading]
          ])
        : _createCommentVNode("", true),
      (_ctx.showCourseNotice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _hoisted_51,
            _createElementVNode("div", _hoisted_52, [
              _createElementVNode("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.term, (info, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "card-body border-top p-9",
                    key: index
                  }, [
                    _createElementVNode("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, [
                        _createElementVNode("div", _hoisted_56, [
                          _hoisted_57,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: `term[${index}].term`,
                            class: "form-control form-control-sm text-right",
                            disabled: "",
                            value: index + 1
                          }, null, 8, ["name", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_58, [
                          _hoisted_59,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: `term[${index}].term_day`,
                            class: "form-control form-control-sm text-right",
                            disabled: "",
                            value: info.term_day
                          }, null, 8, ["name", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_60, [
                          _hoisted_61,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: `term[${index}].term_session`,
                            class: "form-control form-control-sm text-right",
                            disabled: "",
                            value: info.term_session
                          }, null, 8, ["name", "value"])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _hoisted_63,
                          _createVNode(_component_Field, {
                            type: "text",
                            name: `term[${index}].term_hour`,
                            class: "form-control form-control-sm text-right",
                            value: info.term_hour,
                            disabled: ""
                          }, null, 8, ["name", "value"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          (_ctx.term[index].class_type == 1)
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 0,
                                value: "Class Work",
                                class: "form-control form-control-sm text-right",
                                placeholder: "Class Type",
                                name: `term[${index}].classtype`,
                                style: {"width":"100%"},
                                disabled: ""
                              }, null, 8, ["name"]))
                            : _createCommentVNode("", true),
                          (_ctx.term[index].class_type == 2)
                            ? (_openBlock(), _createBlock(_component_Field, {
                                key: 1,
                                value: "Internship",
                                class: "form-control form-control-sm text-right",
                                placeholder: "Class Type",
                                name: `term[${index}].classtype`,
                                style: {"width":"100%"},
                                disabled: ""
                              }, null, 8, ["name"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createVNode(_component_el_form_item, {
                            prop: "date",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.term[index].start_date,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].start_date) = $event),
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                type: "date",
                                name: `term[${index}].start_date`,
                                onBlur: ($event: any) => (
                        _ctx.generatetermEndDate(
                          _ctx.term[index].start_date,
                          info.term_day,
                          _ctx.term[index].week_session,
                          index
                        )
                      )
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onBlur"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createVNode(_component_el_form_item, {
                            prop: "date",
                            class: "mb-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.term[index].end_date,
                                "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].end_date) = $event),
                                "value-format": "YYYY-MM-DD",
                                format: "DD-MM-YYYY",
                                type: "date",
                                name: `term[${index}].end_date`
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("table", _hoisted_72, [
                          _createElementVNode("thead", null, [
                            _createElementVNode("tr", _hoisted_73, [
                              _hoisted_74,
                              _hoisted_75,
                              _hoisted_76,
                              _hoisted_77,
                              _hoisted_78,
                              (_ctx.term[index].class_type == 1)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_79, " Lead Trainer "))
                                : _createCommentVNode("", true),
                              (_ctx.term[index].class_type == 1)
                                ? (_openBlock(), _createElementBlock("th", _hoisted_80, " Associate Trainer "))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.term[index].week_session, (i) => {
                              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                                _createElementVNode("td", _hoisted_81, [
                                  _createVNode(_component_el_select, {
                                    modelValue: _ctx.term[index].day[i],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].day[i]) = $event),
                                    class: "form-select-solid",
                                    placeholder: "Select Day",
                                    name: `term[${index}].day[${i}]`,
                                    filterable: "",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_option, {
                                        label: "Saturday ",
                                        value: "Saturday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Saturday")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Sunday",
                                        value: "Sunday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Sunday")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Monday",
                                        value: "Monday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Monday")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Tuesday ",
                                        value: "Tuesday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Tuesday")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Wednesday",
                                        value: "Wednesday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Wednesday")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Thursday",
                                        value: "Thursday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Thursday")
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_el_option, {
                                        label: "Friday",
                                        value: "Friday"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Friday")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                ]),
                                _createElementVNode("td", _hoisted_82, [
                                  _createVNode(_component_Field, {
                                    class: "form-control form-control-sm text-right",
                                    placeholder: "Select Room",
                                    modelValue: _ctx.term[index].training_room[i],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].training_room[i]) = $event),
                                    filterable: "",
                                    name: `term[${index}].training_room[${i}]`,
                                    style: {"width":"100%"}
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name"])
                                ]),
                                _createElementVNode("td", _hoisted_83, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    type: "time",
                                    placeholder: "Start time",
                                    name: `term[${index}].start_time[${i}]`,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].start_time[i]) = $event),
                                    format: "hh:mm A",
                                    "value-format": "hh:mm A",
                                    style: {"width":"100%"},
                                    onBlur: ($event: any) => (
                            _ctx.getDuration(
                              _ctx.term[index].end_time[i],
                              _ctx.term[index].start_time[i],
                              index,
                              i,
                              info.term_session,
                              info.term_hour,
                              _ctx.term[index].day[i]
                            )
                          )
                                  }, null, 40, _hoisted_84), [
                                    [_vModelText, _ctx.term[index].start_time[i]]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_85, [
                                  _withDirectives(_createElementVNode("input", {
                                    class: "form-control",
                                    type: "time",
                                    placeholder: "End time",
                                    name: `term[${index}].end_time[${i}]`,
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].end_time[i]) = $event),
                                    format: "hh:mm A",
                                    "value-format": "hh:mm A",
                                    style: {"width":"100%"},
                                    onBlur: ($event: any) => (
                            _ctx.getDuration(
                              _ctx.term[index].end_time[i],
                              _ctx.term[index].start_time[i],
                              index,
                              i,
                              info.term_session,
                              info.term_hour,
                              _ctx.term[index].day[i]
                            )
                          )
                                  }, null, 40, _hoisted_86), [
                                    [_vModelText, _ctx.term[index].end_time[i]]
                                  ])
                                ]),
                                _createElementVNode("td", _hoisted_87, [
                                  _createVNode(_component_Field, {
                                    modelValue: _ctx.term[index].duration_hour[i],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].duration_hour[i]) = $event),
                                    type: "text",
                                    name: `term[${index}].duration_hour[${i}]`,
                                    class: "form-control form-control-sm text-right",
                                    onChange: ($event: any) => (
                            _ctx.checkDuration(
                              _ctx.term[index].end_time[i],
                              _ctx.term[index].start_time[i],
                              index,
                              i,
                              info.term_session,
                              info.term_hour
                            )
                          )
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "name", "onChange"])
                                ]),
                                (_ctx.term[index].class_type == '1')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_88, [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.term[index].lead_trainer[i],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].lead_trainer[i]) = $event),
                                        class: "form-select-solid",
                                        placeholder: "Select Org Trainer",
                                        filterable: "",
                                        name: `term[${index}].training_room[${i}]`,
                                        style: {"width":"100%"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainerInfo, (info) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: info.id,
                                              label: info.employee_info.name,
                                              value: info.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(info.employee_info.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_ctx.term[index].class_type == '1')
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_89, [
                                      _createVNode(_component_el_select, {
                                        modelValue: _ctx.term[index].associate_trainer[i],
                                        "onUpdate:modelValue": ($event: any) => ((_ctx.term[index].associate_trainer[i]) = $event),
                                        class: "form-select-solid",
                                        placeholder: "Select Org Trainer",
                                        filterable: "",
                                        name: `term[${index}].training_room[${i}]`,
                                        style: {"width":"100%"}
                                      }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trainerInfo, (info) => {
                                            return (_openBlock(), _createBlock(_component_el_option, {
                                              key: info.id,
                                              label: info.employee_info.name,
                                              value: info.id
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(info.employee_info.name), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["label", "value"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1032, ["modelValue", "onUpdate:modelValue", "name"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.showCourseNotice)
          ? (_openBlock(), _createElementBlock("div", _hoisted_90, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-lg btn-success",
                  type: "button",
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.formSubmit()))
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_92, [
                        _createTextVNode(" Submit "),
                        _createElementVNode("span", _hoisted_93, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_94, [
                        _createTextVNode(" Please wait... "),
                        _hoisted_95
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_91)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}